import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { IUserBase } from '../../../types'
import { ProfileCard } from '../ProfileCard'
import { getUserAvatar } from '../../../utils'
import { TooltipContainer } from '../TooltipContainer'

type Props = {
  item: IUserBase
  shouldDisplayInvestorType?: boolean
}

export const AngelCard: FC<Props> = ({ item, shouldDisplayInvestorType = false }) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  return (
    <ProfileCard
      avatar={getUserAvatar(item)}
      name={item.name}
      jobTitle={shouldDisplayInvestorType ? '' : item.profile.jobTitle}
      href={`/users/${item.username}`}
      isVerifiedAccount={item.profile.isVerifiedAccount}
    >
      {shouldDisplayInvestorType && <div className={styles.angel}>{t('エンジェル投資家')}</div>}
      {item.profile.hasInvestmentsWithJobs && (
        <TooltipContainer text={t('投資先のスタートアップ企業が採用活動中です。')}>
          <div className={styles.job}>{t('投資先求人あり')}</div>
        </TooltipContainer>
      )}
      <p className={styles.text}>{item.profile.bio}</p>
    </ProfileCard>
  )
}
